import { render, staticRenderFns } from "./ScormElementSettings.vue?vue&type=template&id=cb95c1e6&scoped=true&"
import script from "./ScormElementSettings.vue?vue&type=script&lang=ts&"
export * from "./ScormElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb95c1e6",
  null
  
)

export default component.exports